import { 
  FaInternetExplorer, 
  FaUsers, 
  FaBolt, 
  FaGamepad, 
  FaImages, 
  FaTrashAlt,
  FaUserFriends
} from 'react-icons/fa';

const ICONS = {
  'Internet Exploder': FaInternetExplorer,
  'MSN Misdemeanor': FaUserFriends,
  '3D Pinball': FaGamepad,
  'WinScam': FaBolt,
  'FaceLeak': FaUsers,
  'My Pictures': FaImages,
  'Recycle Bin': FaTrashAlt,
};

const ICON_COLORS = {
  'Internet Exploder': '#0078D7',
  'MSN Misdemeanor': '#00A2ED',
  '3D Pinball': '#335DA8',
  'WinScam': '#F59A23',
  'FaceLeak': '#663399',
  'My Pictures': '#FFD700',
  'Recycle Bin': '#808080',
};

export const DesktopIcon = ({ name, onClick, isSelected }) => {
  const IconComponent = ICONS[name] || FaInternetExplorer;
  const iconColor = ICON_COLORS[name] || '#0078D7';

  return (
    <div
      className={`desktop-icon ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      onDoubleClick={onClick}
      data-testid={`desktop-icon-${name.toLowerCase().replace(/\s+/g, '-')}`}
      tabIndex={0}
      role="button"
      aria-label={`Open ${name}`}
    >
      <div className="icon-image">
        <IconComponent size={32} color={iconColor} />
      </div>
      <span className="icon-label">{name}</span>
    </div>
  );
};

export default DesktopIcon;
